// Vuex Script
// Version		          : 1.0.0.0
// Template Modified Date : 5-12-2019 10:00:00 AM
// File Created Date      : 5-12-2019 10:00:00 AM

export default {
    namespaced: true,
    //#. An object containing the data
    state: {
        multiColumn: 1,
        parentComponent: true,
        card: {
            type: 'Form'
        },
        hideButtons: ['Delete'],
        inlineEditor: {
            enabled: true,
            autoSave: true,
            emptyRow: true
        },
        actions: {
            listAction: "/api/WorkFlowModel/GetWorkFlowModelDetail/",
            deleteAction: "/api/WorkFlowModel/",
            updateAction: "/api/WorkFlowModel",
            createAction: "/api/WorkFlowModel",
            //searchAction: "/api/Client/GetClientDetail/"
        },

        fields: {
            ControllerNameId: {
                required: true,
                sortable: true,
                autocomplete: true,
                type: "ComboBox",
                title: "Controller"
            },
            Active: {
                required: true,
                autocomplete: true,
                type: "ComboBox",
                title: "Active"
            },
            CreatedById: {
                type: "Hidden"
            },
            CreatedDate: {
                type: "Hidden"
            },
            UpdatedById: {
                type: "Hidden"
            },
            UpdatedDate: {
                type: "Hidden"
            },
            SysSchemaId: {
                type: "Hidden"
            },

            SysJSON: {
                type: "Hidden"
            },
            CusSchemaId: {
                type: "Hidden"
            },
            CusJSON: {
                type: "Hidden"
            },
            OriginBusinessUnitId: {
                type: "Hidden"
            },
            WorkFlowModelId: {
                primaryKey: true,
            },
            WorkFlowDefinitionId: {
                parent: true
            },
        },
    },
    //#. Used to access data from the state tree of the store
    getters: {},

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {
        //#. fn_formCreated function
        formCreated(state, payload) {
            //  payload.payload.dashboard.componentId = 1;
        },
        formUpdated(state, payload) { },
        //#. fn_formCancel function
        formCancel(state, payload) {
        },

        //#. fn_recordCreated function
        recordCreated(state, payload) {
        },

        //#. fn_recordUpdated function
        recordUpdated(state, payload) {
        },

        //#. fn_recordDeleted function
        recordDeleted(state, payload) {
        },

        //#. fn_loadingRecords function
        loadingRecords(state, payload) {
        },

        //#. fn_recordsLoaded function
        recordsLoaded(state, payload) {
        },
        //#. fn_selectionChanged function
        selectionChanged(state, context) {

            // if (context.payload.fieldName == "Code") {
            //     let currentValue = state.data[state.formData.indexOf(context.payload.item)].Id;
            //     window.location.href = "/Application/CurrencyDetails?mId=109#" + currentValue;
            // }

        }
    },

    //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
    actions: {
        //#. formCreated event will be fired
        formCreated: ({ commit, rootState }, payload) => {
            commit('formCreated', { rootState, payload });
        },
        formUpdated: ({ commit, rootState }, payload) => {
            commit('formUpdated', { rootState, payload });
        },
        //#. formCancel event will be fired
        formCancel: ({ commit, rootState }, payload) => {
            commit('formCancel', { rootState, payload });
        },

        //#. recordAdded event will be fired
        recordCreated: ({ commit, rootState }, payload) => {
            commit('recordCreated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordUpdated: ({ commit, rootState }, payload) => {
            commit('recordUpdated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordDeleted: ({ commit, rootState }, payload) => {
            commit('recordDeleted', { rootState, payload });
        },
        //#. loadingRecords event will be fired
        loadingRecords: ({ commit, rootState }, payload) => {
            commit('loadingRecords', { rootState, payload });
        },

        //#. recordsLoaded event will be fired
        recordsLoaded: ({ commit, rootState }, payload) => {
            commit('recordsLoaded', { rootState, payload });
        },
        selectionChanged: ({ commit, rootState }, payload) => {
            commit('selectionChanged', { rootState, payload });
        }
    }
}